export { SwiperComponent } from './swiper.component';

export { SwiperDirective } from './swiper.directive';

export {
  coverflowObject, coverflowObjectInterface,
  cubeObject, cubeObjectInterface,
  fadeObject, fadeObjectInterface,
  flipObject, flipObjectInterface,
  SwiperConfig, SwiperConfigInterface,
  SwiperEvents
} from './swiper.interfaces';

export {
  provideDefaultConfig, provideForRootGuard,
  SWIPER_CONFIG, SWIPER_GUARD,
  SwiperModule
} from './swiper.module';
